import { Component, Input, Pipe, ViewChild,PipeTransform} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController} from 'ionic-angular';
import { AppSearchItemsProvider } from '../../providers/app-search-items/app-search-items';
import { Keyboard } from '@ionic-native/keyboard';
import { PassPurposePage } from '../pass-purpose/pass-purpose';
import { TranslateService } from '@ngx-translate/core';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';

@IonicPage()
@Component({
  selector: 'page-app-search',
  templateUrl: 'app-search.html',
})

export class AppSearchPage {

  @ViewChild('focusInput') myInput;

  items: any;
  permissions: any;
  itemsWithPermission:itemObj[]=[];
  localstorage:any

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private appItemsProvider: AppSearchItemsProvider,
    private translate: TranslateService,
    private keyboard: Keyboard,
    private perPipe:PermissionCheckPipe,
    private modalCtrl: ModalController) {
    appItemsProvider.getAllItems().then(val => {
      this.items = val;
     this.getItemsWithPermission()

    });
   
    this.localstorage= JSON.parse(localStorage.getItem('loggedinUserIndex'))
    this.permissions=this.localstorage.permissions;
  }
  

  getItems(ev){
    this.appItemsProvider.getItems(ev.target.value).then(val => {
      console.log('inline function',val)
      this.itemsWithPermission = val;
    }).catch(val => {
      console.log(val);
    });
  }

  getItemsWithPermission(){
    this.items.forEach(element => {
      if(this.perPipe.transform(this.permissions,element.mod,element.type)){
        this.itemsWithPermission.push(element)
      }  
    });  }
 

  itemClicked(item: any){
    if(item.page == PassPurposePage){
      let modal = this.modalCtrl.create(PassPurposePage);
      modal.present();
    }else{
      this.navCtrl.push(item.page, item.data);
    }
  }

  ionViewDidLoad() {
    setTimeout(() => {
      console.log("--------------");
      console.log(this.myInput);
      this.keyboard.show();
    },150);
  }

}
interface itemObj {
   name:string, page: any, mod: string, type: string 
}



// WEBPACK FOOTER //
// ./src/pages/app-search/app-search.ts